import * as React from 'react';
import { PageLoadingIndicator } from '@applications/order-tracker/components/page-loading-indicator';
import * as Loadable from 'react-loadable';

const OrderDetailsLazy = Loadable({
    loader: () => import(/* webpackChunkName:"order-details" */'./index'),
    loading(props) {
        return <PageLoadingIndicator loader="spinner" error={props.error}/>
    }
});

export default OrderDetailsLazy;
